import {colorNames, useNamedColor} from '@github-ui/use-named-color'
import {CalendarIcon, MultiSelectIcon, NumberIcon, SingleSelectIcon, TypographyIcon} from '@primer/octicons-react'

import type {IssueFieldDataType} from './__generated__/IssueFieldPickerIssueField.graphql'
import type {IssueFieldSingleSelectOptionColor} from './__generated__/IssueSingleSelectFieldPickerOption.graphql'
import styles from './IssueFieldLeadingVisual.module.css'

export function createIssueFieldPickerItemLeadingVisual(dataType: IssueFieldDataType) {
  if (dataType === 'TEXT') {
    return TypographyIcon
  } else if (dataType === 'SINGLE_SELECT') {
    return SingleSelectIcon
  } else if (dataType === 'MULTI_SELECT') {
    return MultiSelectIcon
  } else if (dataType === 'DATE') {
    return CalendarIcon
  } else if (dataType === 'NUMBER') {
    return NumberIcon
  } else {
    return undefined
  }
}

export const createIssueSingleSelectFieldPickerItemLeadingVisual = (color: IssueFieldSingleSelectOptionColor) => {
  return function IssueSingleSelectFieldPickerItemLeadingVisual() {
    const effectiveColor = colorNames.find(c => c === color)
    const {bg, accent} = useNamedColor(effectiveColor)
    return <div className={styles.colorIndicator} style={{backgroundColor: bg, borderColor: accent}} />
  }
}
